module.exports = __webpack_public_path__ + "static/media/ic_performed_journal.47cfc7af.svg";